import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';
import { PathStyleExtension } from '@deck.gl/extensions';

export const BROWARDCITYLINE_LAYER_ID = 'browardCityLineLayer';

export const CATEGORY_COLORS = {
  'City Line': [241, 100, 119],
};

const layerConfig = {
  title: 'City Lines',
};

function BrowardCityLineLayer() {
  const dispatch = useDispatch();
  const { browardCityLineLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardCityLineLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardCityLineLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDCITYLINE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardCityLineLayer.visible,
      opacity: browardCityLineLayer.opacity,

      getLineColor: [236, 64, 122],
      lineWidthMinPixels: 2,

      getDashArray: [3, 1.5],
      dashJustified: true,
      dashGapPickable: true,
      extensions: [new PathStyleExtension({ dash: true })],

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDCITYLINE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: ['City_Name'],
            }),
          };
        }
      },
    });
  }
}

export default BrowardCityLineLayer;
